import { createFileRoute, Outlet, redirect } from '@tanstack/react-router'
import { getStoredUserRole, marketingLandingPath } from '@/lib/staff-roles'

// /admin/marketing is a layout parent for marketing.{promo-codes,loyalty,
// campaigns}. TanStack's file-based router makes these dotted siblings
// into children automatically (see routeTree.gen.ts), so the parent
// needs to render an <Outlet /> instead of redirecting — a redirect in
// beforeLoad would re-fire for every child match and loop forever.
//
// Bare `/admin/marketing` (no sub-segment) redirects up-front to the
// first tab the role can actually open — /overview for admin, Bank card
// promos for manager (the one marketing surface managers own). Guard
// avoids redirecting when a child route is already matching.
export const Route = createFileRoute('/admin/marketing')({
  beforeLoad: ({ location }) => {
    if (location.pathname === '/admin/marketing' || location.pathname === '/admin/marketing/') {
      throw redirect({ to: marketingLandingPath(getStoredUserRole()) })
    }
  },
  component: () => <Outlet />,
})
